import { withAsyncLoading } from '../../../Components/Templates/Loading/AsyncPageLoading/withAsyncPageLoading';

const LoadableListClientPage = withAsyncLoading(async () =>
    import('./ListClientPage').then((res) => res.ListClientPage)
);

export { LoadableListClientPage };
